const { IconClose } = require('./close');

module.exports = {
  IconClose,
};
